/**
 * Procurement Module Routes (custom extensions)
 *
 * Extends the auto-generated routes with custom routes such as the
 * GIS-observation workflow that is not generated from entity DSL.
 */

import { lazy, Suspense } from 'react'
import { procurementRoutes as generatedProcurementRoutes } from './procurement.generated'

const WorkorderObservePage = lazy(() =>
  import('@/procurement/gis/WorkorderObservePage').then((m) => ({ default: m.WorkorderObservePage }))
)

export const procurementRoutes = [
  ...generatedProcurementRoutes,
  {
    path: '/procurement/workorders/:id/observe',
    element: (
      <Suspense fallback={null}>
        <WorkorderObservePage />
      </Suspense>
    ),
  },
]
